import { api_DELETE, api_GET, api_POST, api_PUT } from "./_api.js";

const unidadeMonetaria_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`UnidadeMonetaria`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`UnidadeMonetaria/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`UnidadeMonetaria`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("UnidadeMonetaria", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    deleteItem: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`UnidadeMonetaria/${json.id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default unidadeMonetaria_api;